import { Alert, Snackbar, useTheme } from '@mui/material';
import React, { createContext, useContext, useState } from 'react';
const NotificationContext = createContext({});

export const useNotification = () => useContext(NotificationContext);

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'error', // Lehet: "success", "info", "warning", "error"
  });
  const theme = useTheme();
  return (
    <NotificationContext.Provider value={{ notification, setNotification }}>
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          variant='filled'
          sx={{
            backgroundColor: theme.palette[notification.severity].main, // ✅ Helyes használat
            color: theme.palette[notification.severity].contrastText, // Kontrasztos szöveg
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
      {children}
    </NotificationContext.Provider>
  );
}
